export class HistoricoSwapModel {
  constructor(
    public readonly codKycLog: number,
    public readonly dataOperacao: string,
    public readonly operacao: string,
    public readonly tabela: string,
    public readonly codRegistro: number,
    public readonly chave: string,
    public readonly detalhe: string,
    public readonly login: string,
    public readonly usuarioBcoDados: string,
    public readonly travaInformacaoTela: string,
    public readonly retornoSwap: string
  ) {}

  static fromJson(json: any): HistoricoSwapModel {
    return new HistoricoSwapModel(
      json.codKycLog ?? 0,
      json.dataOperacao || '',
      json.operacao || '',
      json.tabela || '',
      json.codRegistro ?? 0,
      json.chave || '',
      json.detalhe || '',
      json.login || '',
      json.usuarioBcoDados || '',
      json.travaInformacaoTela || 'NAO',
      json.retornoSwap || ''
    );
  }

  get dataFormatada(): string {
    if (!this.dataOperacao) return '';
    try {
      const date = new Date(this.dataOperacao);
      // Verifica se a data é válida antes de formatar
      if (isNaN(date.getTime())) return this.dataOperacao;
      
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit' // Adicionei segundos já que é um log de auditoria
      });
    } catch {
      return this.dataOperacao;
    }
  }

  // Helper para identificar visualmente o tipo de operação na tela
  get operacaoClass(): string {
    switch (this.operacao?.toUpperCase()) {
      case 'INSERT': return 'text-success';
      case 'UPDATE': return 'text-primary';
      case 'DELETE': return 'text-danger';
      case 'CONSULT': return 'text-info';
      default: return '';
    }
  }
}